import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { Router } from '@angular/router';
//import { ToastrService } from 'ngx-toastr';
import { FaqEditComponent } from 'src/app/faq/faq-edit/faq-edit.component';
import { CallModel } from 'src/app/shared/models/calllog.model';
import { CategoryModel } from 'src/app/shared/models/category.model';
import { ClientModel } from 'src/app/shared/models/client.model';
import { IssueDetailModel, IssueFileModel, IssueModel } from 'src/app/shared/models/issue.model';
import { UserModel } from 'src/app/shared/models/user.model';
import { ClientService } from 'src/app/shared/services/client.service';
import { CommunicationService } from 'src/app/shared/services/communication.service';
import { FaqService } from 'src/app/shared/services/faq.service';
import { IssueCategoryService } from 'src/app/shared/services/issue-category.service';
import { IssueService } from 'src/app/shared/services/issue.service';
import { ProductCategoryService } from 'src/app/shared/services/product-category.service';
import { UserService } from 'src/app/shared/services/user.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-issue-detail',
  templateUrl: './issue-detail.component.html',
  styleUrls: ['./issue-detail.component.css']
})
export class IssueDetailComponent implements OnInit {

  @Input() issue : IssueDetailModel;
  @Input() call : CallModel;
  @Input() users : UserModel [];
  @Input() files : IssueFileModel [];
  @Output() onChangeToEdit: EventEmitter<any> = new EventEmitter<any>();
  @Output() onUpdate: EventEmitter<any> = new EventEmitter<any>();
 // @Output() onChangeSidebar: EventEmitter<any> = new EventEmitter<any>();
  client : ClientModel;
  dialogConfig = new MatDialogConfig();
  modalImage : string;


  constructor(
    private userService : UserService,
    private faqService : FaqService,
    private service :IssueService,
    //private toastr : ToastrService,
    private gnotify : GlobalNotification,
    private router : Router,
    private commservice : CommunicationService,
    private clientservice  : ClientService,
    private dialog : MatDialog
    ) {

      this.dialogConfig.disableClose = true;
      this.dialogConfig.autoFocus = true;
      this.dialogConfig.width = "60%";

    }

  ngOnInit() {

    console.log("ngOnInit");
    if(this.users)
    {
      if(this.issue.createBy != null && this.issue.createByUser == null)
      {
        var item1 =  this.users.filter(x => x.id == this.issue.createBy);
            if(item1 != null && item1.length > 0)
                this.issue.createByUser = item1[0];
      }

      if(this.issue.closeBy != null &&  this.issue.closeByUser == null)
      {
        var item2 =  this.users.filter(x => x.id == this.issue.closeBy);
          if(item2 != null && item2.length > 0)
              this.issue.closeByUser = item2[0];
      }
    }

    var clientId = (this.issue.clientId ? this.issue.clientId : this.issue.callLogClientId)
    if(clientId)
    {
      this.clientservice.getDetail(clientId).subscribe(
        res=>{
          this.client = res as ClientModel;
        },
        err=>
        {
        }

      );
    }


  }

  onCloseIssue()
  {
    if(!confirm("Are you sure to close this issue?")) return;

    this.service.closeIssue(this.issue).subscribe(
      res=>{
        ////this.toastr.success("Submit successfuly", "Issue Close");
        this.gnotify.showSnackBar('Issue Close', 'Submit successfuly', "success");
        this.onUpdate.emit(true);
      },
      err=>{
        console.log(err);
        ////this.toastr.error("Submit failed", "Issue Close");
        this.gnotify.showSnackBar('Issue Close', 'Submit failed', "error");
      }
    );
  }

  onReopenIssue()
  {
    this.service.reopenIssue(this.issue).subscribe(
      res=>{
        ////this.toastr.success("Submit successfuly", "Issue Reopen");
        this.gnotify.showSnackBar('Issue Reopen', 'Submit successfuly', "success");
        this.onUpdate.emit();
      },
      err=>{
        console.log(err);
        ////this.toastr.error("Submit failed", "Issue Reopen");
        this.gnotify.showSnackBar('Issue Reopen', 'Submit failed', "error");
      }
    );
  }

  onAddToFAQ()
  {
    this.faqService.initializeFormGroup();

    this.dialogConfig.data = {
      result : false,
      issue : this.issue
    };
    let dialogRef = this.dialog.open(FaqEditComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
/*
      if(this.dialogConfig.data.result)
      {
          console.log(true);
      }
      else{
        console.log(false);
      }*/
    });

  }

  onEdit()
  {
    this.onChangeToEdit.emit();
  }

  onFindIssue()
  {
    this.commservice.sendTag(true);
    //this.commservice.sendCurrentIssue(IssueDetailModel.convertToIssueModel(this.issue));
  }

  openModal(imagelink) {

    this.modalImage = imagelink;

    console.log(this.modalImage);
    document.getElementById('imgModal').style.display = "block";

  }

  closeModal() {
    document.getElementById('imgModal').style.display = "none";
  }

}
